import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { regexApi } from '../api/regex.api';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';

export const useRegex = () => {
  const [regex, setRegex] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchRegex = useCallback(async () => {
    setLoading(true);
    try {
      const data = await regexApi.getNames();
      setRegex(data);
      return data;
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
      return [];
    } finally {
      setLoading(false);
    }
  }, []);
  return {
    setRegex,
    regex,
    fetchRegex,
    loading,
  };
};
